module.exports = "../../app/cells/components/campaigns/interventions/maxiboard_cell.rb";